module.exports = __webpack_public_path__ + "img/pic03@2x.ae4163e3.png";